import AuditField from "./AuditField";

export default function BlocPatrimoine({ data }) {
  const liquidites = data.liquidites || {};
  const placements = data.placements || {};
  const residenceSecondaire = data.residenceSecondaire || {};
  const investissementLocatif = data.investissementLocatif || {};
  const credits = data.creditsCourtsTermes || [];

  return (
    <section className="space-y-6 bg-white p-6 rounded-xl shadow">
      <h2 className="text-xl font-bold text-gray-800">Patrimoine & Épargne</h2>

      {/* 🏘️ Investissements locatifs */}
      <h3 className="text-lg font-semibold text-gray-700">Investissements locatifs</h3>
      <AuditField label="Possède" value={investissementLocatif.possede ? "Oui" : "Non"} />
      <AuditField label="Nombre de biens" value={investissementLocatif.nombreBiens} />
      {(investissementLocatif.investissements || []).map((inv, i) => (
        <div key={i} className="border p-4 rounded-lg bg-gray-50 mb-4">
          <AuditField label="Type" value={inv.typeInvestissement} />
          <AuditField label="Lieu" value={inv.lieu} />
          <AuditField label="Surface" value={inv.surface + " m²"} />
          <AuditField label="Loyers nets perçus" value={inv.loyersNetPercus + " €"} />
          <AuditField label="Année d'acquisition" value={inv.anneeAcquisition} />
          <AuditField label="Valeur d'acquisition" value={inv.valeurAcquisition + " €"} />
          <AuditField label="Valeur estimée" value={inv.valeurEstimee + " €"} />
          <AuditField label="Capital emprunté" value={inv.capitalEmprunte + " €"} />
          <AuditField label="Taux du crédit" value={inv.tauxCredit + " %"} />
          <AuditField label="Durée du crédit" value={inv.dureeCredit + " ans"} />
          <AuditField label="Capital restant dû" value={inv.capitalRestantDu + " €"} />
          <AuditField label="Mensualité" value={inv.mensualite + " €"} />
        </div>
      ))}

      {/* 💶 Liquidités */}
      <h3 className="text-lg font-semibold text-gray-700">Épargne - Liquidités</h3>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <AuditField label="Compte courant" value={liquidites.compteCourant + " €"} />
        <AuditField label="Livrets" value={liquidites.livrets + " €"} />
        <AuditField label="PEL / CEL" value={liquidites.pelCel + " €"} />
        <AuditField label="Autres" value={liquidites.autres + " €"} />
        <AuditField label="PERCO / PERP" value={liquidites.percoPerp + " €"} />
      </div>

      {/* 📈 Placements */}
      <h3 className="text-lg font-semibold text-gray-700">Épargne - Placements</h3>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <AuditField label="PEA" value={placements.pea + " €"} />
        <AuditField label="PEE" value={placements.pee + " €"} />
        <AuditField label="Compte-titres" value={placements.compteTitre + " €"} />
      </div>
      {(placements.assuranceVie || []).map((a, i) => (
        <div key={i} className="border p-4 rounded-lg bg-gray-50">
          <AuditField label="Assurance vie – Montant" value={a.montant + " €"} />
          <AuditField label="Assurance vie – Supports" value={a.supports} />
        </div>
      ))}

      {/* 💳 Crédits courts termes */}
      <h3 className="text-lg font-semibold text-gray-700">Crédits courts termes</h3>
      {credits.length > 0 ? (
        credits.map((credit, i) => (
          <div key={i} className="border p-4 rounded-lg bg-gray-50">
            <AuditField label="Désignation" value={credit.designation} />
            <AuditField label="Capital emprunté" value={credit.capitalEmprunte + " €"} />
            <AuditField label="Mensualité" value={credit.mensualite + " €"} />
            <AuditField label="Date de fin" value={new Date(credit.dateFin).toLocaleDateString()} />
          </div>
        ))
      ) : (
        <p className="text-sm text-gray-500 italic">Aucun crédit court terme enregistré.</p>
      )}
    </section>
  );
}
